import _ from "lodash";
import React from "react";
import classes from "./GridLayoutWrapper.scss";

const GridLayoutWrapper = ({
  children,
  noOfColumns,
  customGridStyles = {},
  itemsPerRow,
  stretchItemsInLastRow = true,
}) => {
  const filteredChildren = children.filter(child => child !== false);
  const numItems = _.size(filteredChildren);
  const numInLastRow = numItems % itemsPerRow;

  return (
    <div
      className={classes.gridContainer}
      style={{
        ...customGridStyles,
        gridTemplateColumns: `repeat(${noOfColumns},1fr)`,
      }}
    >
      {_.map(filteredChildren, (child, index) =>
        child ? (
          <div
            key={child.key || index}
            style={{
              gridColumn:
                numInLastRow > 0 &&
                index >= numItems - numInLastRow &&
                stretchItemsInLastRow
                  ? `span ${noOfColumns / numInLastRow}`
                  : `span ${noOfColumns / itemsPerRow}`,
            }}
          >
            {child}
          </div>
        ) : null
      )}
    </div>
  );
};

export default GridLayoutWrapper;
